import { autoinformer } from '@shared/components/layout-default/layout-default-nav/items/nav-autoinformer';
import { autocaller_v2 } from '@shared/components/layout-default/layout-default-nav/items/nav-autocaller_v2';
import { call_tracking } from '@shared/components/layout-default/layout-default-nav/items/nav-call-tracking';
import { db } from '@shared/components/layout-default/layout-default-nav/items/nav-db';
import { integration } from '@shared/components/layout-default/layout-default-nav/items/nav-integration';
import { integrations } from '@shared/components/layout-default/layout-default-nav/items/nav-integrations';
import { mailer } from '@shared/components/layout-default/layout-default-nav/items/nav-mailer';
import { hlr } from '@shared/components/layout-default/layout-default-nav/items/nav-hlr';
import { pbx } from '@shared/components/layout-default/layout-default-nav/items/nav-pbx';
import { phone_number } from '@shared/components/layout-default/layout-default-nav/items/nav-phone-number';
import { referral } from '@shared/components/layout-default/layout-default-nav/items/nav-referral';
// import { verification } from '@shared/components/layout-default/layout-default-nav/items/nav-verification';
import { voice } from '@shared/components/layout-default/layout-default-nav/items/nav-voice';
import { predictive_connect } from '@shared/components/layout-default/layout-default-nav/items/nav-predictive_connect';

const nav = [];

nav.push({
  name: 'dashboard',
  title: 'core.breadcrumb.dashboard',
  icon: () => import('@shared/components/icon/sidebar/icon-dashboard.vue'),
  route: { name: 'dashboard' }
});

nav.push(integrations);
nav.push(voice);
nav.push(mailer);
nav.push(hlr);
nav.push(db);
nav.push(phone_number);
nav.push(pbx);
nav.push(autoinformer);
nav.push(autocaller_v2);
nav.push(predictive_connect);
nav.push(referral);
nav.push(call_tracking);
nav.push(integration);
// nav.push(verification);

export default nav;
